import { FavoriteIcon } from 'foundations-assets/icons/components/FavoriteIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { BreezeBadge } from 'trellis-ecosystem';
import { getPartnerTier, getPartnerTierContent } from '../../utils/getPartnerTierContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAYED_PRODUCT_FEATURES = ['MCP_SERVER'];
export function ListingBadges({
  listing
}) {
  var _listing$reviewSummar;
  const product = listing.products[0];
  const rating = (_listing$reviewSummar = listing.reviewSummary) === null || _listing$reviewSummar === void 0 ? void 0 : _listing$reviewSummar.overallRating;
  const partnerTier = getPartnerTier(listing);
  const partnerTierContent = getPartnerTierContent(partnerTier);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: "wrap",
    gap: "200",
    marginBlockStart: "auto",
    paddingBlockStart: "400",
    children: [partnerTierContent !== null && partnerTierContent !== void 0 && partnerTierContent.icon ? /*#__PURE__*/_jsx(Badge, {
      use: partnerTierContent.badgeUse,
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "100",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          color: partnerTierContent.iconColor,
          icon: partnerTierContent.icon,
          padding: "0",
          size: "100"
        }), partnerTierContent.text]
      })
    }) : /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      children: listing.displayTagLabel
    }), listing.products.some(p => p.worksWithBreeze) && /*#__PURE__*/_jsx(BreezeBadge, {}), product.productFeatures.filter(pf => pf.type && DISPLAYED_PRODUCT_FEATURES.includes(pf.type)).map(pf => /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      children: pf.name
    }, `${String(pf.type)}-${pf.name}`)), product.productType === 'SOLUTIONS_PARTNER_PROFILE' && rating !== undefined && /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      display: "flex",
      flexDirection: "row",
      gap: "400",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "100",
        alignItems: "center",
        children: [rating.toFixed(1), /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-core-subtle",
          icon: FavoriteIcon,
          marginBlockEnd: "25",
          padding: "0"
        })]
      })
    })]
  });
}